import React from "react";
import { LogoIcon, LogoTextIcon } from "../../../components/icons";
import LinkExpiredSVG from "../../../assets/link-expired.svg?react";
import { BrandingModel } from "../../../utils/types";

const LinkExpired = ({ branding }: { branding: BrandingModel | null }) => {
  return (
    <div className="w-full flex flex-col">
      {branding && (
        <div
          className="w-full flex items-center px-6 py-3 space-x-3"
          style={{ backgroundColor: branding.navbar_bg_color }}
        >
          {branding.logo_url && (
            <img src={branding.logo_url} alt={branding.company_name} className="h-8 object-contain" />
          )}
          {branding.show_company_name && (
            <span className="text-white font-bold text-sm">{branding.company_name}</span>
          )}
        </div>
      )}
      <div className="w-full h-[calc(100vh-75px)] flex flex-col-reverse tablet-landscape:flex-row">
        <div className="w-full tablet-landscape:w-1/2 flex items-center justify-center h-[50%] tablet-landscape:h-full">
          <div className="w-full h-full flex flex-col justify-start tablet-landscape:justify-center tablet-landscape:text-left text-center">
            <div
              className="text-4xl font-bold tablet-landscape:pl-52"
              style={{ color: branding?.expired_page_title_color ?? "#307CD8" }}
            >
              {branding?.expired_page_title ?? "Oops! your link has expired"}
            </div>
            <div
              className="py-10 tablet-landscape:pl-52 px-10 tablet-landscape:px-0"
              style={{ color: branding?.expired_page_description_color ?? "#0B1C34" }}
            >
              {branding?.expired_page_description ?? (
                <>
                  <span className="font-bold">This URL has expired</span>, please ask your sales
                  manager for a list of your not responded to leads or wait until tomorrow for a new
                  URL to be sent.
                </>
              )}
            </div>
            {branding?.expired_page_support_link && branding?.expired_page_support_text && (
              <a
                href={branding.expired_page_support_link}
                className="tablet-landscape:pl-52 underline text-sm"
                style={{ color: branding.expired_page_title_color }}
                target="_blank"
                rel="noreferrer"
              >
                {branding.expired_page_support_text}
              </a>
            )}
          </div>
        </div>
        <div className="w-full tablet-landscape:w-1/2 p-10 flex items-center justify-center">
          <LinkExpiredSVG />
        </div>
      </div>
      <div className="w-full mt-auto flex items-center justify-center py-3">
        <div className="text-sm text-blue-dark p-2">powered by</div>
        <LogoIcon size={18} color={["blue-dark", "white"]} />
        <LogoTextIcon className="ml-1" size={70} color="blue-dark" />
      </div>
    </div>
  );
};

export default LinkExpired;
